import React from "react";
//import KenyaLogo from "../img/kenya-logo.png";

const Home = () =>{
    
  function closeMenu() {

    document.getElementById('menu-btn').checked=false;

    let anchorSelector = 'a[href^="#"]';

    let anchorList = document.querySelectorAll(anchorSelector);

    anchorList.forEach(link => {
      link.onclick = function () {
        let destination = document.querySelector(this.hash);

        destination.scrollIntoView({
            behavior: 'smooth'
        });
        }
    
    });

  }


    return(
        <section id="home">
            <div className="container" class="px-10 pt-7 max-[420px]:px-4">
                <div>
                    <header className="header" class="header static">
                        <input className="menu-btn" type="checkbox" id="menu-btn"/>
                        <label className="menu-icon" id="menu-icon" for="menu-btn"><span class="navicon"></span></label>
                        <ul className="menu" >
                            <li><a href="#home" onClick={closeMenu} class="anchor">Home</a></li>
                            <li><a href="#about" onClick={closeMenu} class="anchor">About</a></li>
                            <li><a href="#news" onClick={closeMenu} class="anchor">News</a></li>
                            <li><a href="#contact" onClick={closeMenu} class="anchor">Contact</a></li>
                            <li><a href="#covid" onClick={closeMenu} class="anchor" className="rounded-full bg-orange-700" id="orange-btn">COVID details</a></li>
                        </ul>
                    </header>
                    {/* <div className="logo">
                        <img src={KenyaLogo} alt="kenya logo" className=" w-20 float-right max-[800px]:w-13" id="kenyalogo"/>
                    </div> */}
                </div>
                <div className='words' class="mt-64 pb-20 px-8 max-[800px]:mt-32" id="words">
                    <p class="text-white text-xl mt-10 w-1/2 leading-loose text-justify max-[800px]:w-3/4 max-sm:w-full max-md:text-md">Welcome to Afya website. We are a non-profit entity committed to developing the best standards of healthcare in Kenya.</p>
                    <div id="home-btns" className="w-1/3 py-10 grid grid-cols-2 gap-5 max-[1000px]:w-1/2 max-[720px]:w-3/4 max-[640px]:w-full max-[500px]:grid-cols-1">
                        <button className="rounded-full text-white px-7 py-3 bg-orange-700"><a href="#about">learn more</a></button>
                        <button className="rounded-full bg-white text-[#118C5F] font-semibold px-7 py-3"><a href="#news">latest news</a></button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Home


